import Decoline from './Decoline';

export default Decoline;
